import React from 'react'

import styled from '@emotion/styled'
import { mq, black01, pcHeaderH, spHeaderH, hoverFade, breakP, grayBorder, baseDurationTime, green01 } from '../../../_style'
import InViewWrapper from '../inViewWrapper';

const Container = styled.div`
  & > div {
    display: flex;
    padding-left: 115px;
    ${mq.sp} {
      /* padding-left: 15px; */
      padding-left: 0px;
    }
  }
`

export default class HistoryItemBody extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    return(
      <Container>
        <InViewWrapper>
          {this.props.children}
        </InViewWrapper>
      </Container>
    )
  }
}
